export default "__VITE_ASSET__0KtMBCDc__"